const { findWarehouseByLocationId } = require('../../order/tools/read/warehouse-code-to-virtual')

// Helpers for the LMD Source filter (issue #23868), built on the canonical
// warehouse id tooling in order/tools/read/warehouse-code-to-virtual.js:
// funder-split virtual warehouses share one real (physical) warehouse and
// carry its id plus a funder suffix (e.g. 'zone:south-south:name:calabar-pmi'
// is the 'funder:pmi' copy of 'zone:south-south:name:calabar'). The Source
// filter lists only the real warehouses.

// Ids that don't resolve to a hard-coded warehouse definition (e.g. tenants
// without funder-split warehouses) are kept as sent. `findWarehouseByLocationId`
// returns null (rather than throwing) for these, so an unresolved id is an
// explicit branch and genuine lookup errors are not swallowed.
const toRealWarehouseId = (originId) => {
  const match = findWarehouseByLocationId(originId, null)
  return match ? match._id : originId
}

// Collapse shipment origin ids onto their real warehouse ids so the Source
// filter lists each physical warehouse once.
const collapseOriginsToRealWarehouses = (originIds) => {
  const realIds = new Set(originIds.filter(Boolean).map(toRealWarehouseId))
  return [...realIds]
}

// Counterpart of collapseOriginsToRealWarehouses for the selected source:
// resolve it to its real warehouse id, preserving the string/array shape of
// the filter. The query substring-matches the real id, which covers the
// warehouse and all of its funder-split virtual copies; funder scoping is
// enforced by the funder_id user filter (getUserShipmentFilters), which is
// built from the same user funders. No funder suffixes are appended: markets
// without funder-split copies (e.g. RMS, EPN) store the raw warehouse id on
// shipments, and a `<id>-<funder>` pattern matches nothing there, emptying
// the LMD page (issue 24866).
const resolveOriginsToRealWarehouses = (originId) => {
  const origins = (Array.isArray(originId) ? originId : [originId]).filter(Boolean)
  if (origins.length === 0) {
    return originId
  }

  const realIds = [...new Set(origins.map(toRealWarehouseId))]
  return realIds.length === 1 ? realIds[0] : realIds
}

module.exports = {
  collapseOriginsToRealWarehouses,
  resolveOriginsToRealWarehouses
}
